import React, { useMemo } from "react";

/**
 * ActionCardHeader - Reusable header component for action cards
 * Used by both ActionCardView and AppliedActionCard
 */
const ActionCardHeader = ({ action, colors, isMobile, hideDelayedEmoji = false, cardWidth }) => {
  const headerStyle = useMemo(() => ({
    background: colors.header,
    borderBottom: `2px solid ${colors.border}`
  }), [colors.header, colors.border]);

  const showModifier = action.actionType === 'manipulate' || 
    action.actionType === 'delayed_manipulate';

  return (
    <div 
      className={`stock-card-top action-card-header ${isMobile ? 'action-card-header-mobile' : 'action-card-header-desktop'}`}
      style={headerStyle}
    >
      {showModifier ? (
        <>
          {action.actionType === 'delayed_manipulate' && !hideDelayedEmoji && (
            <span className="action-card-emoji">{colors.emoji}</span>
          )}
          <span 
            className={`action-card-modifier ${isMobile ? 'action-card-modifier-mobile' : 'action-card-modifier-desktop'}`}
            style={{ color: colors.border }}
          >
            {(action.actionType === 'manipulate' || action.actionType === 'delayed_manipulate') && (
              action.effectValue > 0 ? `+${action.effectValue}` : `${action.effectValue}`
            )}
          </span>
        </>
      ) : (
        <span className="action-card-emoji">{colors.emoji}</span>
      )}
      <span className={`action-card-name ${isMobile ? 'action-card-name-mobile' : 'action-card-name-desktop'}`}>
        {action.displayValue || action.name}
      </span>
    </div>
  );
};

export default ActionCardHeader;

